module.exports = __webpack_public_path__ + "img/risklevelR2.4ab3215d.png";